import { useMemo } from "react";
import { useLocation } from "react-router-dom";
export type DisplayTicket = {
  ticketId: string;
  name: string;
  purchasedCount: number;
  checkedInCount: number;
  checkedInRate: number;
  redeemableCount: number;
  redeemedCount: number;
  redeemedRate: number;
};
export const useFetchAdminTicket = () => {
  //チケットidをクエリから取得する
  const { search } = useLocation();
  const ticketIds = useMemo(() => {
    const params = new URLSearchParams(search);
    const ticketIds = params.getAll("ticket_id");
    return ticketIds;
  }, [search]);
  //TODO: チケットの取得を後で実装する

  //一旦仮でダミーデータを返す
  const displayTickets: DisplayTicket[] = ticketIds.map((id) => {
    return {
      ticketId: id,
      name: id,
      purchasedCount: 0,
      checkedInCount: 0,
      checkedInRate: 0,
      redeemableCount: 0,
      redeemedCount: 0,
      redeemedRate: 0,
    };
  });

  return displayTickets;
};
